/** A report question and an optional office TV name. */
export interface SearchDisplayIntent {
  topic: string
  name: string | null
}

/** Recognize a request to prepare a page for a TV, without changing a playlist. */
export function searchDisplayIntent(
  question: string
): SearchDisplayIntent | null {
  const match =
    /^(?:put|show|add)\s+(.+?)\s+on\s+(?:(?:the\s+)?(.+?)\s+)?tv[?.!]*$/i.exec(
      question.trim()
    )
  if (!match) return null
  const name = match[2]?.trim() ?? null
  return {
    topic: match[1].trim(),
    name: name && !/^(?:a|the)$/i.test(name) ? name : null
  }
}

/** Open a matching TV or the display picker with the page ready to add. */
export function displaySearchHref(
  editor: string,
  page: string,
  intent: SearchDisplayIntent,
  names: readonly { name: string }[]
): string {
  const wanted = intent.name?.trim().toLowerCase().replace(/\s+/g, '-')
  const match = wanted
    ? names.find(display => display.name.toLowerCase() === wanted)
    : undefined
  const path = match ? `${editor}/${encodeURIComponent(match.name)}` : editor
  return `${path}?${new URLSearchParams({ addPage: page })}`
}

/** Read a typed, local page parameter. The editor still checks the service catalogue before using it. */
export function readDisplayAddSearch(search: Record<string, unknown>): {
  addPage?: string
} {
  return {
    addPage:
      typeof search.addPage === 'string' &&
      /^\/[a-z0-9/-]+$/.test(search.addPage) &&
      !search.addPage.startsWith('//')
        ? search.addPage
        : undefined
  }
}
